// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Zapytaj Amigo',
    assistant: 'Asystent',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Zapytaj Amigo, nowe: {{count}}',
    amigo_few: 'Zapytaj Amigo, nowe: {{count}}',
    amigo_many: 'Zapytaj Amigo, nowe: {{count}}',
    amigo_other: 'Zapytaj Amigo, nowe: {{count}}',
    assistant_one: 'Asystent, nowe: {{count}}',
    assistant_few: 'Asystent, nowe: {{count}}',
    assistant_many: 'Asystent, nowe: {{count}}',
    assistant_other: 'Asystent, nowe: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo niedostępny',
    assistant: 'Asystent niedostępny',
  },
  unavailable_text: {
    amigo: 'Amigo jest teraz niedostępny.',
    assistant: 'Asystent jest teraz niedostępny.',
  },
};
